// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Same rationale as `features/tour-edit/constants.ts`: a presign that never gets an ack must fail
 * loudly rather than leaving the UI stuck in "uploading" forever.
 */
export const PHOTO_UPLOAD_TIMEOUT_MS = 60000;

/** Matches TourPhotoLimits.MaxCaptionLength in tour-service. */
export const MAX_CAPTION_LENGTH = 280;

/** Matches TourPhotoLimits.MaxPhotosPerTour in tour-service. */
export const MAX_PHOTOS_PER_TOUR = 200;

/**
 * Multi-select cap. Ten 5 MB photos over a course's mobile connection is already a long wait, and
 * uploads are sequenced rather than parallel, so this bounds the worst case.
 */
export const MAX_SELECTION = 10;

/** Rejected client-side too, so the picker fails fast instead of round-tripping a presign. */
export const MAX_PHOTO_BYTES = 15 * 1024 * 1024;

/**
 * ImageSharp (the server-side resize) cannot decode HEIC, so anything outside this set is rejected
 * at presign time. Keep in sync with TourPhotoPresignHandler.AllowedContentTypes.
 */
export const ALLOWED_PHOTO_CONTENT_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

/**
 * Grid sizing. The column count is derived from the available width rather than fixed, because a
 * fixed 3 columns produces ~500px tiles on a desktop browser. Aim for roughly this tile size and
 * let the count follow, clamped so a phone still gets 3 across and a wide monitor does not turn
 * into a contact sheet.
 */
export const GRID_TARGET_TILE = 170;
export const GRID_MIN_COLUMNS = 3;
export const GRID_MAX_COLUMNS = 8;
export const GRID_GAP = 4;
